
import { getSubdomain, fetchWithAuth } from '../helpers';
import { API_PASSWORD } from '../config';

export const getBankTransactions = async (branchId) => {
  const subdomain = getSubdomain(); // لو بتستخدم نظام subdomain
  const apiPassword = "Project102$_";

  const apiUrl = `https://${subdomain}.restocash.app/api/get/bank/transactions/${branchId}?api_password=${apiPassword}`;

  try {
    console.log("📡 إرسال طلب لجلب معاملات البنك عبر:", apiUrl);

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`, // Pass the token for authentication
      },
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في جلب معاملات البنك:", data);
      throw new Error(data?.message || "فشل في جلب معاملات البنك.");
    }

    console.log("✅ تم جلب معاملات البنك بنجاح:", data);
    return data;
  } catch (error) {
    console.error("🔥 خطأ أثناء الاتصال بالسيرفر:", error);
    throw error;
  }
};



// 